var map = {
	"./401.png": "b959a",
	"./404.png": "16f4",
	"./500.png": "849a",
	"./aniversariantes.png": "ebe6",
	"./app-default-banner.jpg": "38b2",
	"./backoffice-not-allowed.svg": "4c1e",
	"./bg-banner-login.svg": "8f2a",
	"./blue_arrow.svg": "d338",
	"./clientes_unicos.png": "4494",
	"./club-card-dialog-negative.svg": "8391",
	"./club-card-dialog-positive.svg": "d282",
	"./communicate-by-channel.svg": "9e74",
	"./empty_card.png": "d1b8",
	"./empty_decomposition.png": "c5df",
	"./empty_state.png": "1082",
	"./expired.png": "c6a4",
	"./flash_sale_preview.svg": "ef1e",
	"./grey_arrow.svg": "99de",
	"./highlight-products-images/product-beats-1.png": "0a28",
	"./highlight-products-images/product-beats-2.png": "98bb",
	"./highlight-products-images/product-bud.png": "e00b",
	"./highlight-products-images/product-cheetos.png": "dfd0",
	"./highlight-products-images/product-coca.png": "4ded",
	"./highlight-products-images/product-crunch.png": "dd19",
	"./highlight-products-images/product-meat.png": "bead",
	"./highlight-products-images/product-strawberry.png": "97c2",
	"./icons/apple-touch-icon-114x114.png": "02fc",
	"./icons/apple-touch-icon-120x120.png": "05d3",
	"./icons/apple-touch-icon-144x144.png": "756c",
	"./icons/apple-touch-icon-152x152.png": "d1a1",
	"./icons/apple-touch-icon-57x57.png": "f229",
	"./icons/apple-touch-icon-60x60.png": "ce2d",
	"./icons/apple-touch-icon-72x72.png": "dfc0",
	"./icons/apple-touch-icon-76x76.png": "8c36",
	"./icons/codicon:activate-breakpoints.svg": "1ff6",
	"./icons/consultar-ze.png": "7bda",
	"./icons/facebook-icon.png": "9795",
	"./icons/favicon-128.png": "356b",
	"./icons/favicon-16x16.png": "0d9e",
	"./icons/favicon-196x196.png": "a3f6",
	"./icons/favicon-32x32.png": "d254",
	"./icons/favicon-96x96.png": "f94d",
	"./icons/icon-maria-outlined.svg": "14a0",
	"./icons/insta-icon.png": "ac56",
	"./icons/inventory_2.svg": "af35",
	"./icons/linkedin-icon.png": "ef05",
	"./icons/mar.ia-cor.svg": "9b8c",
	"./icons/mar.ia-grey.svg": "18b1",
	"./icons/mar.ia-secondary.svg": "e026",
	"./icons/mar.ia.svg": "ee73",
	"./icons/monetization_on.svg": "847a",
	"./icons/mstile-144x144.png": "2c79",
	"./icons/mstile-150x150.png": "0404",
	"./icons/mstile-310x150.png": "23c5f",
	"./icons/mstile-310x310.png": "710e",
	"./icons/mstile-70x70.png": "3e8f",
	"./icons/swap_vert.png": "5093",
	"./icons/tiktok-icon.png": "a444",
	"./icons/twitter-icon.png": "2055",
	"./icons/voucher-expired.svg": "b702",
	"./icons/voucher-neutral.svg": "96df",
	"./icons/voucher-used.svg": "ebf1",
	"./icons/whats-icon.png": "9165",
	"./icons/whatsapp-marca-0-l20.svg": "f573",
	"./icons/whatsapp.svg": "7583",
	"./icons/youtube-icon.png": "886a",
	"./incremental-revenue-empty-state-pulse.svg": "97e4",
	"./logo.png": "cf05",
	"./logo_dark.png": "9b15",
	"./logo_non_dark.png": "13e7",
	"./logotipo-mercafacil-dark.svg": "15c4",
	"./maintenance.png": "b3d2",
	"./maintenance.svg": "8817",
	"./media_de_compras_por_cliente.png": "aeb8",
	"./media_de_itens_na_cesta.png": "8e5f",
	"./mercafacil-dark.svg": "be74",
	"./modelo.png": "0513",
	"./modelos-segmento/aniversariantesdodia.png": "303e",
	"./modelos-segmento/cadastrosnosultimos7dias.png": "1723",
	"./modelos-segmento/comprarammespassado.png": "73b8",
	"./modelos-segmento/homensde18a60anos.png": "18e1",
	"./modelos-segmento/inativosrecentes.png": "d3278",
	"./modelos-segmento/modeloembranco.png": "1809",
	"./modelos-segmento/nuncacompraram.png": "740a",
	"./modelos-segmento/pfcomticketmediode50a100reais.png": "0ab9",
	"./modelos-segmento/riscodeperder.png": "157c",
	"./new-analyse.svg": "9ff0",
	"./novo.png": "362af",
	"./offline-number-tip-v2.png": "387a",
	"./offline-number-tip.png": "6b93",
	"./on-approval-raffle.png": "f72c",
	"./price-range/catedral.png": "f210",
	"./price-range/copacabana.png": "20a3",
	"./price-range/cristo.png": "c484",
	"./price-range/elevador-lacerda.png": "aedea",
	"./price-range/faixa.png": "f0c7",
	"./price-range/jardim-botanico.png": "a43e",
	"./price-range/museu.png": "acc0",
	"./price-range/pao-de-acucar.png": "8ffe",
	"./price-range/ponto1.png": "0622",
	"./price-range/ponto2.png": "0788",
	"./push.png": "ba25",
	"./reportExportTrackingLoader.png": "c490",
	"./sem_acesso.png": "7d12",
	"./smart-dark.svg": "a988",
	"./store_pin.png": "7c2e",
	"./store_pin_shadow.png": "6c18",
	"./styles/global.scss": "c860",
	"./tribanco-dark.svg": "230d",
	"./unitsGroupsEmptyState.svg": "d197",
	"./update.png": "090e",
	"./valor_medio_dos_produtos.png": "dc06",
	"./voucher-empty.svg": "26ef",
	"./warning_cart.png": "838c",
	"./wpp.png": "f43a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";